'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    { find, omit } = require('underscore'),
    update = require('react/lib/update'),
    guid = require('simple-guid'),
    StampStore = require('../stores/StampStore'),
    SafeLocalStorage = require('../utils/SafeLocalStorage'),
    getUniqueStampImages = require('../utils/getUniqueStampImages'),
    { migrateGrabbagFromOldEditor } = require('../utils/Migrations'),
    PaginatedStoreUtils = require('../utils/PaginatedStoreUtils'),
    ImageStore = require('./ImageStore'),
    assign = require('react/lib/Object.assign'),
    { createIndexedListStore, createListActionHandler } = PaginatedStoreUtils;

var _uploadedImageItems = [];

var STORAGE_KEY = 'grabbag';

function findItem(id) {
  return _uploadedImageItems.indexOf(find(_uploadedImageItems, item => item.uuid === id));
}

function findItemByPath(filePath) {
  return _uploadedImageItems.indexOf(find(_uploadedImageItems, item => item.filePath === filePath));
}

function loadGrabbagFromStorage() {
  var json = SafeLocalStorage.getItem(STORAGE_KEY);
  _uploadedImageItems = json ? JSON.parse(json) : [];
}

function addGrabbagItem(filePath) {
  var item = {
    filePath: filePath,
    progress: 0,
    uuid: guid(),
    image: null
  };

  _uploadedImageItems = update(_uploadedImageItems, {
    $splice: [[0, 0, item]]
  });
}

function updateGrabbagItem(filePath, data) {
  var index = findItemByPath(filePath),
      updateData = {};

  if (index === -1) {
    return;
  }

  updateData[index] = {
    $merge: data
  };

  _uploadedImageItems = update(_uploadedImageItems, updateData);
}

function deleteGrabbagItemByPath(filePath) {
  var index = findItemByPath(filePath);
  if (index === -1) {
    return;
  }

  _uploadedImageItems = update(_uploadedImageItems, {
    $splice: [[index, 1]]
  });
}

function deleteGrabbagItemById(id) {
  var index = findItem(id);
  if (index === -1) {
    return;
  }

  _uploadedImageItems = update(_uploadedImageItems, {
    $splice: [[index, 1]]
  });
}

var GrabbagImageStore = createIndexedListStore({
  getUploadedImageItems() {
    return _uploadedImageItems;
  },

  getSavedImageItems() {
    return this.getIds('saved').map(id => {
      var image = ImageStore.get(id);
      return {
        uuid: image.uuid,
        image: assign(
          { sourceImage: image.uuid, sourceStamp: image.stamp },
          omit(image, ['uuid', 'caption', 'sourceImage', 'sourceStamp', 'stamp'])
        )
      };
    });
  },

  getStampletImageItems() {
    return this.getIds('stamplet').map(id => {
      var image = ImageStore.get(id);
      return {
        uuid: image.uuid,
        image: omit(image, ['uuid', 'caption', 'sourceImage', 'sourceStamp', 'stamp'])
      };
    });
  },

  isEmpty() {
    return !_uploadedImageItems.length && !this.getIds('saved').length && !this.getIds('stamplet').length;
  }
});

var handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_GRABBAG_IMAGES,
  error: ActionTypes.REQUEST_GRABBAG_IMAGES_ERROR,
  success: ActionTypes.REQUEST_GRABBAG_IMAGES_SUCCESS
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([StampStore.dispatchToken, ImageStore.dispatchToken]);

  var action = payload.action;

  if (action.tab) {
    handleListAction(action, GrabbagImageStore.getList(action.tab), GrabbagImageStore.emitChange);
  }

  switch (action.type) {
  case ActionTypes.LOAD_EMPTY_DRAFT:
    _uploadedImageItems = [];

    GrabbagImageStore.emitChange();
    break;

  case ActionTypes.LOAD_STAMP_IN_EDITOR:
    _uploadedImageItems = [];

    GrabbagImageStore.emitChange();
    break;

  case ActionTypes.LOAD_DRAFT_IN_EDITOR_SUCCESS:
    let draft = StampStore.get(action.draftUuid);

    _uploadedImageItems = draft.grabbag || [];

    GrabbagImageStore.emitChange();
    break;

  case ActionTypes.LOAD_STAMP_IN_EDITOR_SUCCESS:
    let stamp = StampStore.get(action.stampId);

    _uploadedImageItems = getUniqueStampImages(stamp).map(image => {
      return {
        uuid: guid(),
        image: omit(image, 'caption', 'uuid')
      };
    });

    GrabbagImageStore.emitChange();
    break;

  case ActionTypes.POST_STAMP_SUCCESS:
    _uploadedImageItems = [];
    break;

  case ActionTypes.ADD_GRABBAG_ITEM:
    addGrabbagItem(action.filePath);
    GrabbagImageStore.emitChange();
    break;

  case ActionTypes.UPDATE_GRABBAG_ITEM:
    updateGrabbagItem(action.filePath, action.data);

    GrabbagImageStore.emitChange();
    break;

  case ActionTypes.DELETE_GRABBAG_ITEM:
    if (action.itemId) {
      deleteGrabbagItemById(action.itemId);
    } else if (action.filePath) {
      deleteGrabbagItemByPath(action.filePath);
    }

    GrabbagImageStore.emitChange();
    break;

  case ActionTypes.IMAGE_ADD_TO_GRABBAG_SUCCESS:
    GrabbagImageStore.getList('saved').invalidate();
    break;

  case ActionTypes.IMAGE_REMOVE_FROM_GRABBAG_SUCCESS:
    GrabbagImageStore.getList('saved').remove(action.uuid);
    GrabbagImageStore.emitChange();
    break;

  case ActionTypes.IMAGE_REMOVE_STAMPLET_ITEM_SUCCESS:
    GrabbagImageStore.getList('stamplet').remove(action.uuid);
    GrabbagImageStore.emitChange();
    break;
  }
});

loadGrabbagFromStorage();

if (GrabbagImageStore.isEmpty()) {
  migrateGrabbagFromOldEditor();
  loadGrabbagFromStorage();
}


module.exports = GrabbagImageStore;



/** WEBPACK FOOTER **
 ** ./stores/GrabbagImageStore.js
 **/